(function () {
  const setProperty = (box, kind, value) => {
    const root = box.closest('product-info') || document;
    const named = box.querySelector('[data-split-' + kind + '-input]');
    if (named) named.value = value;

    const formId = named && named.getAttribute('form');
    const form =
      (formId && document.getElementById(formId)) ||
      root.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;

    const name = kind === 'top' ? 'properties[Top Size]' : 'properties[Bottom Size]';
    let hidden = form.querySelector('[name="' + name + '"]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = name;
      form.appendChild(hidden);
    }
    hidden.value = value;
  };

  const selectVariantSize = (box, value) => {
    const root = box.closest('product-info') || document;
    const input = [...root.querySelectorAll('variant-selects input[type="radio"], variant-radios input[type="radio"]')].find(
      (el) => el.value === value
    );
    if (!input || input.checked) return;
    input.checked = true;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const setValue = (box, kind, value, syncVariant) => {
    box.querySelectorAll('[data-split-' + kind + ']').forEach((btn) => {
      const selected = btn.getAttribute('data-split-' + kind) === value;
      btn.classList.toggle('is-selected', selected);
      btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    setProperty(box, kind, value);
    if (kind === 'top' && syncVariant !== false) selectVariantSize(box, value);
  };

  const hideSizePicker = (root) => {
    if (!root) return;
    root.querySelectorAll('variant-selects fieldset, variant-radios fieldset').forEach((fieldset) => {
      const values = [...fieldset.querySelectorAll('input, option')].map((el) => (el.value || '').toLowerCase());
      if (values.includes('custom size') || values.includes('xs') || values.includes('xxl')) {
        fieldset.hidden = true;
        fieldset.setAttribute('data-split-size-hidden', 'true');
      }
    });
  };

  window.ragaviInitSplitSize = function (root) {
    const scope = root || document;
    scope.querySelectorAll('[data-split-size-pilot]').forEach((box) => {
      hideSizePicker(box.closest('product-info') || scope);

      const pick = (kind) => {
        const selected = box.querySelector('[data-split-' + kind + '].is-selected');
        if (selected) return selected.getAttribute('data-split-' + kind);
        const small = box.querySelector('[data-split-' + kind + '="S"]');
        if (small) return 'S';
        const first = box.querySelector('[data-split-' + kind + ']');
        return first ? first.getAttribute('data-split-' + kind) : null;
      };

      const topVal = pick('top');
      const bottomVal = pick('bottom');
      if (topVal) setValue(box, 'top', topVal, false);
      if (bottomVal) setValue(box, 'bottom', bottomVal, false);
    });
  };

  document.addEventListener('click', (event) => {
    const chart = event.target.closest('[data-open-size-chart]');
    if (chart) {
      event.preventDefault();
      const root = chart.closest('product-info') || document;
      const opener = root.querySelector('.product-popup-modal__button') || document.querySelector('.product-popup-modal__button');
      if (opener) opener.click();
      return;
    }

    const btn = event.target.closest('.split-size-button');
    if (!btn) return;
    const box = btn.closest('[data-split-size-pilot]');
    if (!box) return;
    event.preventDefault();

    const top = btn.getAttribute('data-split-top');
    const bottom = btn.getAttribute('data-split-bottom');
    if (top) setValue(box, 'top', top);
    if (bottom) setValue(box, 'bottom', bottom);
  });

  document.addEventListener('product-info:loaded', (event) => {
    window.ragaviInitSplitSize(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.ragaviInitSplitSize(document));
  } else {
    window.ragaviInitSplitSize(document);
  }
})();
